import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { Box, Toolbar } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import { openDrawer } from 'store';
import MissedPunchAlertModal from 'pages/MissedPunchAlert/MissedPunchAlertModal';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const dispatch = useDispatch()

    const { drawerOpen } = useSelector((state) => state.menu);

    // drawer toggler
    const [open, setOpen] = useState(drawerOpen);
    const handleDrawerToggle = () => {
        setOpen(!open);
        dispatch(openDrawer({ drawerOpen: !open }));
    };

    const handleMouseLeave = () => {
        setOpen(false);
        dispatch(openDrawer({ drawerOpen: false }));
    };

    useEffect(() => {
        if (open !== drawerOpen) setOpen(drawerOpen);
    }, [drawerOpen]);
    
    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <Header open={open} handleDrawerToggle={handleDrawerToggle} />
            <Drawer open={open} handleMouseLeave={handleMouseLeave} handleDrawerToggle={handleDrawerToggle} />
            <Box component="main" sx={{ width: 'calc(100% - 60px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
                <Toolbar />
                <Outlet />
            </Box>
            <MissedPunchAlertModal />
        </Box>
    );
};

export default MainLayout;
